import { types, flow } from 'mobx-state-tree';
import { UserChangeListItem, UserChangeDetail } from './UserChange';
import API from './../../api/userChanges';
import requsetErrorMessage from '../../helpers/requsetErrorMessage';

const UserChanges = types
    .model('UserChanges', {
        userChanges: types.array(UserChangeListItem),
        currentUserChange: types.maybeNull(UserChangeDetail),
        totalPages: types.optional(types.number, 0),
        selectedPage: types.optional(types.number, 1),
        searchQuery: types.optional(types.string, ''),
        error: types.union(
            types.optional(types.string, ''),
            types.optional(types.array(types.string), []),
        ),
        dataLoaded: types.optional(types.boolean, false),
    })
    .actions((self) => ({
        getUserChanges: flow(function* getUserChanges(searchQuery, userId) {
            self.error = '';
            try {
                const res = yield API.getUserChanges({
                    params: {
                        search: searchQuery ? searchQuery : undefined,
                        user_id: userId,
                        limit: 10,
                        page: self.selectedPage,
                    },
                });
                self.dataLoaded = true;
                self.userChanges = res.data.items;
                self.totalPages = res.data.total_pages_count;
            } catch (error) {
                console.log(error);
                self.dataLoaded = true;
                self.error = requsetErrorMessage(error && error.message ? error.message : error);
            }
        }),
        getUserChange: flow(function* getUserChange(id) {
            self.error = '';
            self.dataLoaded = false;
            try {
                const res = yield API.getUserChange(id);
                self.dataLoaded = true;
                self.currentUserChange = res.data;
            } catch (error) {
                console.log(error);
                self.dataLoaded = true;
                self.error = requsetErrorMessage(error && error.message ? error.message : error);
            }
        }),
        clearUserChange() {
            self.currentUserChange = null;
        },
        setSelectedPage(page) {
            self.selectedPage = page;
        },
        setSearchQuery(query) {
            self.searchQuery = query;
        },
    }));

export default UserChanges;
